export const DRUM_STATES = 'DRUM_STATES'
export const DRUM_FREE_RENTAL = 'DRUM_FREE_RENTAL'
export const EVENTS = 'EVENTS'
